export default __webpack_public_path__ + "static/media/aerial-view-container-cargo-ship-sea.d3e9c257.jpg";